import React from 'react';
import { ArticleTextWideImage } from '@components/ArticleImage/ArticleTextWideImage';
import { BlockContentContext } from '../../BlockContent.utils';
import { Image, ImageSerializerProps } from '../components/WideImageSerializer/WideImageSerializer';

export const WideImageSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value: { image, mobileImage } }: ImageSerializerProps) => (
      <ArticleTextWideImage image={image} mobileImage={mobileImage} />
    );
  }
  return ({ value }: ImageSerializerProps) => <Image value={value} />;
};
